<template>
  <div :class="[
        {
          'adv-cart-product-list': true,
          'is-minicart': miniCart,
          'is-cart': !miniCart
        }
      ]"
  >
    <adv-cart-product-row
      v-for="(cartProduct, index) in cartProductContents"
      :key="index"
      :mini-cart="miniCart"
      :read-only="readOnly"
      :disable-product-links="disableProductLinks"
      :cart-product="cartProduct"></adv-cart-product-row>
  </div>
</template>

<script>
import store from '../../vue/store'
import AdvCartProductRow from './AdvCartProductRow'

export default {
  name: 'AdvCartProductList',
  components: {
    AdvCartProductRow
  },
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    cartProductContents () {
      return store.getters.cartContents
    },
    getSelectedCurrency () {
      return store.getters.selectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.adv-cart-product-list {
  width: 100%;
}
</style>
